import { useTranslation } from 'react-i18next';
import { GLOBAL_NAVIGATION_HEIGHT } from '@/shared/lib/constants';
import { useRouteSidePanelStore } from '@/shared/stores/side-panel-store';
import { Banner } from '@/shared/ui';
import { SideMenuHeader } from '@/widgets/right-side-menu/ui/SideMenuHeader';
import { RevenueEditForm } from './RevenueEditForm';

/**
 * 歳入コード振り結果 訂正サイドパネル
 *
 * 歳入テーブルの行を選択した際に表示されるコンテナ。
 * ヘッダーと RevenueEditForm を配置する。
 */
export const RevenueEditSidePanel = () => {
  const { t } = useTranslation();
  const requestClose = useRouteSidePanelStore((state) => state.requestClose);
  const mode = useRouteSidePanelStore((state) => state.mode);

  const initialFormValue =
    mode?.type === 'settlement-statistics-converter.revenue-edit' ? mode : undefined;

  return (
    <div
      className="flex flex-col overflow-hidden"
      style={{ height: `calc(100vh - ${GLOBAL_NAVIGATION_HEIGHT}px)` }}
    >
      <SideMenuHeader
        onClose={() => {
          requestClose();
        }}
      />
      {initialFormValue ? (
        <RevenueEditForm
          convertResultId={initialFormValue.convertResultId}
          selectedRevenue={initialFormValue.revenue}
          onClose={requestClose}
        />
      ) : (
        <Banner
          type="error"
          title={t('common.status.error')}
          description={t('common.status.no-data')}
        />
      )}
    </div>
  );
};
